module.exports = __webpack_public_path__ + "media/images/icons/twotone/pie-chart-49ea57a641a2ef2d87e9cb7cb7b8ad4d.svg";